import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { HiEllipsisHorizontal } from "react-icons/hi2";
import moment from 'moment';

const CustomDateFilter = ({ column: { filterValue = [], setFilter } }) => {
  const [startDate, endDate] = filterValue.map(dateString => dateString ? moment(dateString).toDate() : null);

  const handleStartDateChange = (date) => {
    const formattedDate = date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : null;
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss') : null;
    setFilter([formattedDate, formattedEndDate]);
  };

  const handleEndDateChange = (date) => {
    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss') : null;
    const formattedDate = date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : null;
    setFilter([formattedStartDate, formattedDate]);
  };

  return (
    <div className="react-date-range">
      <div className='react-date-input append'>
        <DatePicker
          selected={startDate}
          onChange={handleStartDateChange}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          placeholderText="Start Date"
          className="form-control from-date"
        />
      </div>
      <span className="react-date-input-text"><HiEllipsisHorizontal /></span>
      <div className='react-date-input prepend'>
        <DatePicker
          selected={endDate}
          onChange={handleEndDateChange}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          placeholderText="End Date"
          className="form-control to-date"
        />
      </div>
    </div>
  );
};

export default CustomDateFilter;
